<template>
  <div>
    <Navbar />  
    <div style="display: flex; align-items: center; justify-content: center;" class="sections--bg">
      <video v-show="collections[id].withVideo" id="collection-video" width="70%" :src="collections[id].video" controls autoplay></video>
    </div>
    <section class="sections sections--bg" :style="[collections[id].withVideo ? {'margin-top': '-15px'} : {'margin-top': '50px'}]">
      <v-container>
        <v-row class="mb-10">
          <v-col cols="12" sm="4">
            <div class="sections-box">
              <div class="sections--border">
                <span class="sections--title">Detil Songket</span>
                <h2 class="sections--menu">{{collections[id].name}}</h2>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8" class="pr-15">
            <p style="white-space: pre-line;">
              {{collections[id].description}}
            </p>
          </v-col>
          <v-col cols="12" sm="4" class="details--line pl-5">
            <v-list class="details--list">
              <v-list-item v-for="(detail, index) in collections[id].details" :key="index">
                <v-list-item-content>
                  <v-list-item-title class="white--text">
                    {{ detail }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="details--sosmed mt-10">
              <!-- <p class="mb-0 pl-3">Share</p> -->
              <v-btn
                v-for="(social, i) in socials"
                :key="i"
                :color="social.color"
                class="white--text"
                fab
                icon
              >
                <v-icon>{{ social.icon }}</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row align="center" class="mt-16">
          <v-col>
            <v-divider color="white" inset></v-divider>
          </v-col>
          <v-col class="ma-auto text-center">
            <span class="text-sm-h4 text-uppercase details--title">Foto</span>
          </v-col>
          <v-col>
            <v-divider class="ml-0" color="white" inset></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="(item, index) in collections[id].images" :key="index" cols="12" sm="4" class="d-flex justify-center">
            <v-card flat class="sections--img">
              <div class="sections--img__zindex">
                <div class="d-flex">
                  <img
                    class="sections--img__resp"
                    alt="gambar"
                    :src="item.url"
                  />
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-col class="details--button">
      <v-row class="py-8">
        <v-col cols="12" sm="6">
          <v-icon color="white">mdi-chevron-left</v-icon> Koleksi Sebelumnya
        </v-col>
        <v-divider color="white" vertical></v-divider>
        <v-col cols="12" sm="6">
          Koleksi Selanjutnya <v-icon color="white">mdi-chevron-right</v-icon>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-row>
        <v-col cols="12" class="text-center details--more py-8 text-capitalize">
          See all Collection
        </v-col>
      </v-row>
    </v-col>
    <Footer />
    <FloatButton />
  </div>
</template>

<script>
import Navbar from "../components/TheNavbar";
import Footer from "../components/TheFooter";
import FloatButton from "../components/TheFloatingButton.vue";

export default {
  name: "Detail",
  components: {
    Navbar,
    Footer,
    FloatButton
  },
  data() {
    return {
      id: "",
      details: [
        "Katun",
        "P. 118 cm, L. 53 cm",
        "Batang Lupar, Kalimantan Barat",
        "Akhir abad ke-19",
        "No. Inv. 6230"
      ],
      socials: [
        {
          icon: "mdi-facebook"
        },
        {
          icon: "mdi-twitter"
        },
        {
          icon: "mdi-instagram"
        }
      ],
      collections: [
        {
          code: "baju",
          name: "BAJU LAMPUNG",
          description: "Berasal dari wilayah Margalima, Krui, yang terletak di pesisir Lampung, baju ini juga disebut baju tampan karena dijahit secara simetris dari kain tampan. Busana adat ini dipadupadankan dengan sarung atau tapis yang melingkari dada hingga mata kaki dan biasa dikenakan oleh perempuan bangsawan yang belum menikah. Lembaran kain tampan dibuat dari katun pintal tangan yang ditenun dengan teknik tenun sederhana. \n \nMotifnya dibuat dari benang sutra warna coklat dan kuning dan benang katun pintal tangan warna biru yang dibuat menggunakan teknik songket (pakan tambahan). Motif yang terdapat dari baju ini adalah kapal, kait, dan sosok manusia. Kapal dan kait memiliki arti siklus kehidupan manusia. Dalam kepercayaan adat saibatin Lampung, kapal diyakini mengantarkan manusia hingga ke tempat peristirahatan terakhir. Sementara sosok manusia digambarkan sebagai makhluk yang menjalankan siklus kehidupan.",
          video: require(`@/assets/img/banners/collection_1.mp4`),
          withVideo: true,
          images: [
            {
              url: require(`@/assets/img/collections/collection_1/1.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_1/2.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_1/3.jpg`)
            }
          ],
          details: [
            "Katun, sutra",
            "L: 131 cm, T: 46.5 cm",
            "Pesisir Barat, Lampung",
            "Akhir abad ke-19",
            "No. Inv. 4140"
          ]
        },
        {
          code: "kalambi",
          name: "KALAMBI",
          description: "Kalambi atau jaket biasa dipakai oleh perempuan atau laki-laki, yang mana jenis kalambi tanpa lengan biasa dipakai oleh kalangan kelas sosial atas suku Dayak Undup (salah satu rumpun suku Dayak Iban), seperti kepala adat. Dasar kalambi ini dibuat dengan tenun sederhana, sedangkan motifnya dibuat menggunakan teknik pakan tambahan. Kalambi menggunakan menggunakan kapas pintal tangan dengan pewarna alam merah dan biru dan bermotif mirip pola anyaman khas buatan suku Dayak Iban. \n \n Bagian depan kainnya dihias motif leku sawa, yaitu ular piton yang melingkar dengan batas berupa pantak lelambak (pola bunga dan tawon). Bagian bawah kalambi dihias motif serupa motif kukut burong atau cakar burung dengan motif dabong mayang atau bunga mayang yang bergerigi. Pada bagian belakang dihias serupa motif engkaramba (figur manusia) dan motif aji (tikus).",
          video: require(`@/assets/img/banners/collection_2.mp4`),
          withVideo: true,
          images: [
            {
              url: require(`@/assets/img/collections/collection_2/1.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_2/2.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_2/3.jpg`)
            }
          ],
          details: [
            "Katun",
            "P. 52 cm, L. 66 cm",
            "Kalimantan Barat",
            "Akhir abad ke-19",
            "No. Inv. 2164"
          ]
        },
        {
          code: "kampuh",
          name: "KAMPUH",
          description: "Songket kampuh termasuk ke dalam wastra agung yang hanya dipakai oleh raja, keluarga, dan bangsawan dalam lingkup kerajaan. Itulah mengapa aspek-aspek seperti komposisi bahan & motif pada kampuh memberikan kesan kebesaran, kemewahan, serta kemegahan. Warna terang dan meriah dipakai oleh kasta atau golongan triwangsa (brahmana, ksatria, dan waisya) dan biasanya berkembang di pusat-pusat kerajaan seperti Badung, Klungkung, Buleleng, Karangasem, dan Jembrana. \n \nBahannya pun terbuat dari sutra dan dibuat dengan teknik tenun sederhana, sementara motifnya dibuat dengan teknik pakan tambahan menggunakan benang emas lilit kertas dan benang sutra. Teknik songket (benang pakan tambahan) di Bali sudah digunakan sejak sekitar abad ke-16 dan dengan kebudayaan Hindu Bali dan juga motif-motif khas Bali. Bagian tubuh kampuh dihiasi songket benang emas motif bunga yang disusun menyerupai bangun berulang geometris. \n \nBagian kepala dihias songket benang sutra aneka warna membentuk motif tumpal pohon hayat dan kupu-kupu. Berdasarkan konsepsi pengetahuan orang Bali, pohon menjadi elemen yang sangat penting, sebab pohon dan manusia dianggap sebagai saudara yang saling bekerja sama dan saling jaga. Kampuh koleksi Museum Nasional ini merupakan diduga sebagai salah satu hadiah yang diberikan oleh raja-raja Karangasem kepada pemerintah Hindia Belanda dalam kurun waktu antara tahun 1865 hingga 1889.",
          img: require(`@/assets/img/highlight/3.png`),
          withVideo: false,
          images: [
            {
              url: require(`@/assets/img/collections/collection_3/1.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_3/2.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_3/3.jpg`)
            }
          ],
          details: [
            "Sutra, benang emas",
            "P. 236 cm; L. 152,5 cm",
            "Bali",
            "Akhir abad ke-19",
            "No. Inv. 7224"
          ]
        },
        {
          code: "ija",
          name: "IJA DUA BLAH HAH",
          description: "Nama unik kain ija dua blah hah memiliki arti kain dua belas jengkal – setara dengan dua belas hasta atau lebih dari lima meter. Kain ini digunakan oleh pengantin wanita dengan cara dililitkan pada tubuh dan menutup kepala layaknya kerudung. Ciri khas kain yang diperkirakan berusia lebih dari 100 tahun ini tampak pada ukurannya yang sangat panjang dan cara penggunaan yang sesuai dengan unsur ajaran Islam terkait menutup aurat bagi perempuan. \n \nKarena terbuat dari sutra dan ditenun dengan teknik sederhana hingga menjadi satu bidang yang sangat panjang, hanya golongan bangsawan serta orang-orang kaya yang mampu membelinya. Bagian tengahnya polos berwarna ungu tua, sementara pada kedua ujung kain terdapat beberapa motif yang dibuat dari benang perak (lilit logam perak). Motif-motif tersebut antara lain bungong kalimah (kaligrafi) yang bertuliskan Allah dalam aksara Arab tersusun rapi di tepian kain dan tumpal berisi motif daun sirih. Hiasan ujung songket sedikit berbeda satu sama lain, dimana ujung yang lebih banyak berhiaskan songket benang perak merupakan kepala kain dan berada pada bagian depan ketika digunakan. Sedangkan ujung lain yang memiliki hiasan songket lebih sedikit adalah bagian belakang ketika digunakan.",
          img: require(`@/assets/img/highlight/4.png`),
          withVideo: false,
          images: [
            {
              url: require(`@/assets/img/collections/collection_4/1.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_4/2.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_4/3.jpg`)
            }
          ],
          details: [
            "Sutra, benang perak",
            "P. 541 cm, L. 84 cm",
            "Aceh",
            "Awal abad ke-19",
            "No. Inv. 21472"
          ]
        },
        {
          code: "pahudu",
          name: "LAU PAHIKUNG/PAHUDU",
          description: "Masyarakat Sumba Timur mengenal teknik menenun benang tambahan, khususnya lungsi, yang dalam bahasa lokal mereka disebut pahikung atau pahudu. Secara tradisional, pahikung atau pahudu memiliki warna dasar hitam atau merah, sedangkan warna lungsi tambahan sebagai pembentuk motif menggunakan warna putih. Warna-warna tersebut merupakan pewarna alam seperti indigo dan mengkudu. Lau pahikung koleksi Museum Nasional ini dibuat dan digunakan oleh perempuan bangsawan. Namun, sekarang masyarakat biasa dapat membuat dan menggunakan lau pahikung. \n \nSarung ini ditenun dengan bahan benang kapas pintal tangan dengan benang lungsi tambahan menggunakan benang kapas pintal mesin (benang toko). Seluruh bagian kain dipenuhi motif, kecuali pada bagian atas. Umumnya, motif gambaran makhluk hidup dipadukan motif geometris, membuat kain semakin indah. Motif utama lau adalah manusia (tau) dan keladi tengkorak (andungu), sementara motif ayam diletakkan di baris atas, bawah, dan menjadi bidang pengisi. Motif adungu ini hadir pada masyarakat Sumba melalui budaya masa lalu, yakni peperangan dan pemenggalan kepala musuh.",
          img: require(`@/assets/img/highlight/5.png`),
          withVideo: true,
          images: [
            {
              url: require(`@/assets/img/collections/collection_5/1.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_5/2.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_5/3.jpg`)
            }
          ],
          details: [
            "Katun",
            "T. 126,5 cm; K. 120 cm",
            "Sumba Timur, Nusa Tenggara Timur",
            "Pertengahan abad ke-20",
            "No. Inv. 30514"
          ]
        },
        {
          code: "sarung",
          name: "SARUNG",
          description: "Di Sumbawa, sarung seperti ini disebut Kre Alang. Terdiri dari dua bidang, sarung ini dibuat dengan teknik tenun sederhana menggunakan benang kapas pintal tangan dan dipadukan dengan benang perak sebagai pakan tambahan untuk membentuk motif hias. Bagian kepala sarung dihiasi dengan motif perahu, ayam jantan, dan tumpal yang masing-masing memiliki makna. Perahu mencitrakan hubungan abadi antara manusia dan Tuhan. Perahu ini juga dapat diartikan sebagai perahu arwah, yang akan mengantar arwah manusia menuju akhirat. Sementara itu, ayam jantan melambangkan kesadaran akan waktu dan keabadian. Sarung dengan motif-motif tersebut digunakan oleh bangsawan pada saat upacara kematian. \n \nKain tenun kaum bangsawan biasanya disongket dengan benang perak tambahan untuk membuat ragam hias. Berbeda dengan songket dari daerah lain, songket Sumbawa memiliki ragam hias dengan keunikan tersendiri. Di Sumbawa, ragam hias yang sering digunakan antara lain bunga teratai, perahu (sekarang sulit ditemukan), figur manusia, fauna, serta motif geometris. \n \nPenggunaan motif figur mahluk hidup pada kain songket Sumbawa ini menjadi sebuah ciri yang sangat menonjol, karena jarang sekali ditemukan dalam kebudayaan bercorak Islam. Sebelum pertengahan abad ke-20, kain songket di Sumbawa hanya ditenun oleh atau di bawah pengawasan perempuan bangsawan. Seiring berkembangnya zaman, kini kain songket Sumbawa dapat dibuat ataupun dipakai oleh semua kalangan.",
          img: require(`@/assets/img/highlight/6.png`),
          withVideo: false,
          images: [
            {
              url: require(`@/assets/img/collections/collection_6/1.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_6/2.jpg`)
            },
            {
              url: require(`@/assets/img/collections/collection_6/3.jpg`)
            }
          ],
          details: [
            "Katun, benang perak",
            "P. 138 cm, L. 184 cm",
            "Sumbawa, Nusa Tenggara Barat",
            "Awal abad ke-20",
            "No. Inv. 20535"
          ]
        }
      ]
    };
  },
  mounted() {
    this.id = this.$route.params.id
    window.scrollTo(0,0);
    var video = document.getElementById('collection-video');
    video.play();
  }
};
</script>

<style lang="scss" scoped></style>
